import { Base, Response } from '@.api/methods';

import { CurrenciesResponseType, CurrenciesType, CurrencyResponseType } from './types';

export class Currencies extends Base {
    public getAll(query?: { page?: number; per_page?: number }) {
        this.setPath('currencies');
        if (query) this.setQuery(query);

        return this.getRequest() as Response<CurrenciesResponseType>;
    }

    public getById(id: number) {
        this.setPath('currencies');
        this.setId(id);

        return this.getRequest() as Response<CurrencyResponseType>;
    }

    public create(data: CurrenciesType) {
        this.setPath('currencies');
        this.setData(data);

        return this.postRequest();
    }

    public update(id: number, data: CurrenciesType) {
        this.setPath('currencies');
        this.setId(id);
        this.setData(data);

        return this.putRequest();
    }

    public delete(id: number) {
        this.setPath('currencies');
        this.setId(id);

        return this.deleteRequest();
    }

    public restore(id: number) {
        this.setPath('currencies');
        this.setId(`${id}/restore`);

        return this.postRequest();
    }
}
